import { NgModule } from '@angular/core';
import {
  OccProductSearchAdapter,
  PRODUCT_NORMALIZER,
  PRODUCT_SEARCH_PAGE_NORMALIZER,
  ProductAdapter,
  ProductReferencesAdapter,
  ProductReviewsAdapter,
  provideConfig
} from '@spartacus/core';
import { ViewConfig } from '@spartacus/storefront';
import { KnBrOccProductSearchAdapter } from '../core/services/kn-br-product-search.service';
import { ProductPrettyNameNormalizer } from '../roots/converters/kn-br-product-name.normalizer';
import { KnProductSearchPageNormalizer } from '../roots/converters/kn-br-product-search-page.normalizer';
import { KnBrOccProductReferencesAdapter } from './adapters/kn-br-occ-product-references.adapter';
import { KnBrOccProductReviewsAdapter } from './adapters/kn-br-occ-product-reviews.adapter';
import { KnBrOccProductAdapter } from './adapters/kn-br-occ-product.adapter';
import { knBrProductEndpointsConfig, knBrProductViewConfig } from './config/kn-br-product.config';

@NgModule({
  imports: [],
  providers: [
    provideConfig(knBrProductEndpointsConfig),
    provideConfig(<ViewConfig>knBrProductViewConfig),
    {
      provide: ProductAdapter,
      useClass: KnBrOccProductAdapter,
    },
    {
      provide: ProductReferencesAdapter,
      useClass: KnBrOccProductReferencesAdapter,
    },
    {
      provide: ProductReviewsAdapter,
      useClass: KnBrOccProductReviewsAdapter,
    },
    {
      provide: OccProductSearchAdapter,
      useClass: KnBrOccProductSearchAdapter,
    },
    {
      provide: PRODUCT_SEARCH_PAGE_NORMALIZER,
      useClass: KnProductSearchPageNormalizer,
      multi: true,
    },
    {
      provide: PRODUCT_NORMALIZER,
      useExisting: ProductPrettyNameNormalizer,
      multi: true,
    },
  ],
})
export class KnBrProductOccModule { }
